import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import config from '../../config';

import PasswordHint from './PasswordHint';
import useContainerQuery from '../../hooks/useContainerQuery';

const REGEX_LOWERCASE = /[a-z]/;
const REGEX_UPPERCASE = /[A-Z]/;
const REGEX_DIGIT = /\d/;

const MINI_SIZE = '350px';

function PasswordHints({ password = '' }) {
    const minLength = config.get('minPasswordLength');
    password = typeof password === 'string' ? password : '';

    const lengthOk = password.length >= minLength;
    const lowerCaseOk = REGEX_LOWERCASE.test(password);
    const upperCaseOk = REGEX_UPPERCASE.test(password);
    const digitsOk = REGEX_DIGIT.test(password);

    const { ref, widths } = useContainerQuery({ widthBreaks: [MINI_SIZE] });
    const isMini = widths[MINI_SIZE];

    return (
        <div
            ref={ref}
            className={cn('password-hints', { 'password-hints--mini': isMini })}
        >
            <PasswordHint type="length" mini={isMini} ok={lengthOk} labelProps={{ minLength }} />
            <PasswordHint type="lowercase" mini={isMini} ok={lowerCaseOk} labelProps={{ minLength }} />
            <PasswordHint type="uppercase" mini={isMini} ok={upperCaseOk} labelProps={{ minLength }} />
            <PasswordHint type="digit" mini={isMini} ok={digitsOk} labelProps={{ minLength }} />
        </div>
    );
}

PasswordHints.propTypes = {
    password: PropTypes.string,
};

export default PasswordHints;
